import { Alert, Box, Grid, Snackbar } from "@mui/material";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { InterviewOtherWrapper } from "./style";
import ChatSection from "./ChatSection";
import moment from "moment";
import _ from "lodash";
import SpeechRecognition, {
  useSpeechRecognition,
} from "react-speech-recognition";
import VideoSection from "./VideoSection";
import InterviewWelcome from "./InterviewWelcome";
import EmailOTPVerification from "../../../components/common-components/EmailOTPVerification";
import {
  useValidateInterviews,
  useSubmitInterview,
  useUploadAudio,
  useBlockInterviewMutation,
  useSendInterviewOTP,
} from "../../../store/query/scheduleInterviewQuery";
import { useLocation } from "react-router-dom";
import InvalidTokenDialog from "./InvalidTokenDialog";
import MeetingTimeDilogue from "./MeetingTimeDilogue";
import FullScreenLoader from "../../../components/common-components/FullScreenLoader";
import { FullScreen, useFullScreenHandle } from "react-full-screen";
import logo from "../../../assets/Images/element-wordmark-dark.svg";
import Coassistant from "../../../assets/Images/Coassistant.jpeg";
import FaceAuthentication from "./FaceAuthentication";
import useSpeechToText from "react-hook-speech-to-text";
import ToastProvider from "../../../contexts-hooks/providers/ToastProvider";
import InterviewFullScreenDilogue from "./InterviewFullScreenDilogue";
import { playAudioResilient } from "../../../utils/playAudioResilient";
import InterviewStatusDialogue from "../../../components/common-components/InterviewStatusDilogueBox";


const Interview = () => {
  const handle = useFullScreenHandle();
  const { transcript, resetTranscript, listening } = useSpeechRecognition();
  const interviewSubmitMutation = useSubmitInterview();
  const interviewValidateMutation = useValidateInterviews();
  const sendInterviewOTPMutation = useSendInterviewOTP();
  const uploadAudioMutation = useUploadAudio();
  const localVideoRef = useRef(null);
  const audioRef = useRef(null);
  const [localStream, setLocalStream] = useState(null);
  const [isOtpVerified, setIsOtpVerified] = useState(false);
  const [maskedEmail, setMaskedEmail] = useState("");
  const [candidateName, setCandidateName] = useState("");
  const [otpErrorMsg, setOtpErrorMsg] = useState("");
  const [startTime, setStartTime] = useState(null);
  const [endTime, setEndTime] = useState(null);
  const [showQuestions, setShowQuestions] = useState(false);
  const [showStartTimer, setShowStartTimer] = useState(false);
  const [timeLeft, setTimeLeft] = useState(moment.duration(3, "minutes"));
  const [isRunning, setIsRunning] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [interviewDetail, setInterviewDetail] = useState(null);
  const [interviewQuestions, setInterviewQuestions] = useState([]);
  const [interviewDialogueBoxError, setInterviewDialogueBoxError] = useState({
    open: false,
    message: "",
    showStartButton: false,
  });
  const [interviewTimeLeft, setInterviewTimeLeft] = useState(null);
  const [chunks, setChunks] = useState([]);
  const chunkref = useRef([]);
  const [showAnswer, setShowAnswer] = useState(null);
  const [currentAnswer, setCurrentAnswer] = useState(0);
  const [loadings, setLoadings] = useState(false);
  const [conclusion, setConclusion] = useState([]);
  const [isQuestionEnd, setIsQuestionEnd] = useState(false);
  const [isInterviewSubmited, setIsInterviewSubmited] = useState({
    open: false,
    message: "",
    title: "",
  });
  const [faceDetection, setFaceDetection] = useState(false);
  const [isNet, setIsNet] = useState(false);
  const [isValidTime, setIsValidTime] = useState(false);
  const currentAnswerRef = useRef(currentAnswer);
  const isFirstQuestionRef = useRef(true);
  const isQuestionEndRef = useRef(isQuestionEnd);
  const tranascriptRef = useRef(transcript);
  const [facenotdetected, setFaceNotDetected] = useState({
    open: false,
    message: "",
  });
  const [isUserAuthentic, setIsUserAuthentic] = useState(false);
  const [audioFile, setAudioFile] = useState(null);
  const [audioRecord, setAudioRecord] = useState(null);
  const [isInterviewCancel, setIsInterviewCancel] = useState(false);
  const mediaRef = useRef(null);
  const [btnEnable, setBtnEnable] = useState(false);

  const [showPopup, setShowPopup] = useState(false);
  const [isInterviewCompleted, setIsInterviewCompleted] = useState(false);

  const [pendingApiCalls, setPendingApiCalls] = useState(new Set());
  const [isProcessingQuestion, setIsProcessingQuestion] = useState(false);
  const [isTimerExpired, setIsTimerExpired] = useState(false);
  const timeoutIdRef = useRef(null);

  const [isStartButtonDisabled, setIsStartButtonDisabled] = useState(false);

  // STATE FROM WELCOME-SCREEN
  const [showWelcomeScreen, setShowWelcomeScreen] = useState(true);
  const [startVerification, setStartVerification] = useState(false);
  const [isBlocked, setIsBlocked] = useState(false);
  const [isInterviewStarted, setIsInterviewStarted] = useState(false);
  const showSnackbar = (message, severity = "info") => {
    if (isInterviewCompletedRef.current || isInterviewSubmited?.open) return;
    setSnackbar((prev) => ({
      ...prev,
      open: true,
      message,
      severity,
    }));
  };
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "info",
  });
  const [isStickyWarning, setIsStickyWarning] = useState(false);

  // STATE FROM TAB SWITCH
  const blockInterviewMutation = useBlockInterviewMutation();
  const tabSwitchCountRef = useRef(0);
  const isInterviewCompletedRef = useRef(false);

  const handleInterviewBlockByTabSwitch = () => {
    if (isBlocked || !interviewDetail?._id) return;
    blockInterviewMutation.mutate(interviewDetail._id, {
      onSuccess: () => {
        setIsBlocked(true);
        SpeechRecognition.stopListening();
        if (timeoutIdRef.current) clearTimeout(timeoutIdRef.current);

        setIsRunning(false);
        setShowQuestions(false);

        if (mediaRef.current?.state === "recording") {
          mediaRef.current.stop();
        }

        handleStopStream();
        handle.exit();

        setIsInterviewSubmited({
          open: true,
          title: "Blocked!",
          message:
            "This interview is blocked. Please contact your administrator.",
        });
      },
      onError: (err) => {
        console.error("Failed to block interview", err);
      },
    });
  };

  useEffect(() => {
    isInterviewCompletedRef.current = isInterviewCompleted;
  }, [isInterviewCompleted]);

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (!isInterviewStarted || isBlocked || isInterviewCompletedRef.current)
        return;

      if (document.visibilityState === "hidden") {
        tabSwitchCountRef.current += 1;
        const count = tabSwitchCountRef.current;
        if (count === 1 || count === 2) {
          showSnackbar(
            `Warning: Switching tabs during the interview is not allowed. (${count}/4)`,
            "warning"
          );
        } else if (count === 3) {
          showSnackbar(
            "Warning 3/4: Switching tabs during interview is not allowed. One more violation will cancel your interview.",
            "warning"
          );
          setIsStickyWarning(true);
        } else if (count >= 4) {
          showSnackbar(
            "Multiple violations detected. Interview has been blocked.",
            "error"
          );
          setIsStickyWarning(false);
          handleInterviewBlockByTabSwitch();
        }
      }
    };

    const RESTRICTED_KEYS = {
      Tab: true,
      PrintScreen: true,
      Meta: true,
      F12: true,
    };

    const handleKeyDown = (e) => {
      if (!isInterviewStarted || isBlocked || isInterviewCompletedRef.current)
        return;

      // if (!isInterviewStarted || isBlocked) return;

      const isRestricted =
        RESTRICTED_KEYS[e.key] ||
        (e.ctrlKey && ["p", "i", "j"].includes(e.key.toLowerCase())) ||
        (e.altKey && e.key === "Tab") ||
        (e.metaKey && e.key === "Tab");

      if (isRestricted) {
        e.preventDefault();
        window.focus();
        showSnackbar("Keyboard shortcuts are disabled.", "warning");
      }
    };

    const preventAction = (e, msg) => {
      if (!isInterviewStarted || isBlocked || isInterviewCompletedRef.current)
        return;

      // if (!isInterviewStarted || isBlocked) return;
      e.preventDefault();
      showSnackbar(msg, "warning");
    };

    const handleContextMenu = (e) =>
      preventAction(e, "Right-click is disabled");
    const handleCopy = (e) => preventAction(e, "Copy is not allowed");
    const handlePaste = (e) => preventAction(e, "Paste is not allowed");

    document.addEventListener("visibilitychange", handleVisibilityChange);
    window.addEventListener("keydown", handleKeyDown);
    document.addEventListener("contextmenu", handleContextMenu);
    document.addEventListener("copy", handleCopy);
    document.addEventListener("paste", handlePaste);

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
      window.removeEventListener("keydown", handleKeyDown);
      document.removeEventListener("contextmenu", handleContextMenu);
      document.removeEventListener("copy", handleCopy);
      document.removeEventListener("paste", handlePaste);
    };
  }, [isInterviewStarted, isBlocked]);

  const handleStartFromWelcome = () => {
    setShowWelcomeScreen(false);
  };

  // Tab switch End

  const onFullScreenChange = useCallback(
    (state) => {
      if (!isInterviewStarted) return;
      if (isBlocked) return;
      if (isInterviewCompleted) return;
      if (!state) {
        setShowPopup(true);
      } else {
        setShowPopup(false);
      }
    },
    [isInterviewStarted, isBlocked, isInterviewCompleted]
  );

  const handleLocalStream = async () => {
    try {
      const constraints = { video: true, audio: true };
      const stream = await navigator.mediaDevices.getUserMedia(constraints);
      if (localVideoRef.current) {
        localVideoRef.current.setSinkId("");
        localVideoRef.current.muted = true;
        localVideoRef.current.srcObject = stream;
      }
      setLocalStream(stream);
      setIsStartButtonDisabled(false);
    } catch (error) {
      setIsStartButtonDisabled(true);
      console.error("Error accessing the camera:", error);
      alert(
        "Unable to access the camera and microphone. Please check your device settings."
      );
    }
  };

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const token = queryParams.get("token");
  const handleValidationError = (errors) => {
    setErrorMessage(errors.message);
    if (errors.message === "This Interview is Cancelled") {
      setIsInterviewSubmited({
        open: true,
        message: "This interview is Cancelled",
        title: "Cancelled!",
      });
    } else if (errors.message === "This Link is expired") {
      setIsInterviewSubmited({
        open: true,
        message: "This Link is Expired",
        title: "Expired!",
      });
    } else {
      setIsInterviewSubmited({
        open: true,
        message: "Please contact your administrator to resolve this issue",
        title: "Invalid Link!",
      });
    }
  };
  useEffect(() => {
    if (!token) return;
    setLoadings(false);
    setShowPopup(false);
    setIsStartButtonDisabled(true);
    interviewValidateMutation.mutate(
      { token: token },
      {
        onSuccess: (data) => {
          setLoadings(false);
          if (data.otpRequired) {
            setMaskedEmail(data.maskedEmail || "");
            setCandidateName(data.candidateName || "");
          } else if (data.interviewDetail) {
            setIsOtpVerified(true);
            handleLocalStream();
            validateUserInterviewTime(data);
            setInterviewDetail(data.interviewDetail);
            setInterviewQuestions(data.interviewDetail.questions || []);
          }
        },
        onError: (error) => {
          handleValidationError(error.response?.data || { message: "Invalid Link" });
        },
      }
    );
    return () => {
      handleStopStream();
    };
  }, [token]);

  const handleSendOTP = async () => {
    try {
      setOtpErrorMsg("");
      const res = await sendInterviewOTPMutation.mutateAsync({ token });
      if (res?.maskedEmail) {
        setMaskedEmail(res.maskedEmail);
      }
      return true;
    } catch (err) {
      setOtpErrorMsg(err.response?.data?.message || "Failed to send OTP. Please try again.");
      return false;
    }
  };

  const handleVerifyOTP = (otpCode) => {
    setOtpErrorMsg("");
    setLoadings(true);
    interviewValidateMutation.mutate(
      { token: token, otp: otpCode },
      {
        onSuccess: (data) => {
          setLoadings(false);
          setIsOtpVerified(true);
          handleLocalStream();
          validateUserInterviewTime(data);
          setInterviewDetail(data.interviewDetail);
          setInterviewQuestions(data.interviewDetail.questions || []);
        },
        onError: (error) => {
          setLoadings(false);
          setOtpErrorMsg(
            error.response?.data?.message || "Invalid or expired OTP verification code."
          );
        },
      }
    );
  };
  useEffect(() => {
    if (isValidTime) {
      if (isNet) {
        if (faceDetection) {
          setFaceNotDetected({
            open: false,
            message: "",
          });
          setShowStartTimer(true);
        } else {
          setFaceNotDetected({
            open: true,
            message: "Face not detected. Please turn on your camera",
          });
        }
      }
    }
  }, [faceDetection, isNet, isValidTime]);

  const validateUserInterviewTime = (data) => {
    if (data.interviewDetail.status === "Completed") {
      setIsInterviewCompleted(true);
      isInterviewCompletedRef.current = true;

      setSnackbar((prev) => ({ ...prev, open: false }));
      setIsStickyWarning(false);

      setShowPopup(false);
      setIsInterviewSubmited({
        open: true,
        message:
          "Thank you for your interest in joining Element Technologies. We look forward to speaking with you and learning more about your expertise.",
        title: "Interview Completed",
      });
      return;
    }
    // BLOCKED
    if (data.interviewDetail.status === "Blocked") {
      setShowPopup(false);
      setIsInterviewSubmited({
        open: true,
        message:
          "This interview is blocked. Please contact your administrator.",
        title: "Blocked!",
      });
      return;
    }

    const currentTime = moment.utc();
    const starttime = moment(data.interviewDetail.startTime);
    const endedtime = moment(data.interviewDetail.endTime);
    const validTime = currentTime.isBetween(starttime, endedtime);
    const isBeforeTime = currentTime.diff(endedtime);
    setStartTime(data?.interviewDetail?.startTime);
    setEndTime(data?.interviewDetail?.endTime);

    if (validTime) {
      setInterviewDialogueBoxError((prev) => ({
        open: true,
        message: "Start the interview",
        showStartButton: true,
      }));
    } else {
      setIsValidTime(false);
      if (isBeforeTime < 0) {
        setInterviewDialogueBoxError((prev) => ({
          ...prev,
          open: true,
          showStartButton: false,
        }));
      } else {
        setInterviewDialogueBoxError({
          open: true,
          message: `Interview ended The meeting has ended`,
          showStartButton: false,
        });
      }
    }
  };
  const startInterview = () => {
    if (isBlocked) return; // Blocked

    const finalizeStart = () => {
      setIsValidTime(true);
      if (interviewDetail?.questions) {
        setInterviewQuestions(interviewDetail.questions);
      }
      handleLocalStream();
      setOpen(false);
      setInterviewDialogueBoxError({
        open: false,
        message: "",
        showStartButton: false,
      });
      setIsInterviewStarted(true);
      setStartVerification(true);
    };

    handle
      .enter()
      .then(() => {
        finalizeStart();
      })
      .catch((err) => {
        console.error("Fullscreen request failed. Proceeding anyway...", err);
        finalizeStart();
      });
  };

  useEffect(() => {
    if (!isRunning || timeLeft.asSeconds() <= 0) return;

    const intervalId = setInterval(() => {
      setTimeLeft((prevTime) =>
        moment.duration(prevTime.asSeconds() - 1, "seconds"),
      );
    }, 1000);

    return () => clearInterval(intervalId);
  }, [isRunning, timeLeft]);

  const handleStart = async () => {
    setIsRunning(true);
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      mediaRef.current = new MediaRecorder(stream);

      mediaRef.current.ondataavailable = (e) => {
        console.error("Data available:", e.data);
        setChunks((prevChunks) => [...prevChunks, e.data]);
        chunkref.current.push(e.data);
      };

      mediaRef.current.onerror = (error) => {
        console.error("MediaRecorder error:", error);
      };

      mediaRef.current.start();
    } catch (err) {
      console.error("Error accessing the microphone: ", err);
    }
  };
  const handleResetTimer = () => {
    setTimeLeft(moment.duration(3, "minutes"));
  };
  const handleStartRecord = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      mediaRef.current = new MediaRecorder(stream);

      mediaRef.current.ondataavailable = (e) => {
        setChunks((prevChunks) => [...prevChunks, e.data]);
      };

      mediaRef.current.onerror = (error) => {
        console.error("MediaRecorder error:", error);
      };

      mediaRef.current.start();
      console.error("Recording started.");
    } catch (err) {
      console.error("Error accessing the microphone: ", err);
    }
  };

  const handleAudioEnd = async () => {
    setBtnEnable(true);
    if (timeoutIdRef.current) {
      clearTimeout(timeoutIdRef.current);
    }
    await handleStart();

    setTimeout(() => {
      setShowAnswer(true);
      SpeechRecognition.startListening({ continuous: true });
      handlePlayQuestion();
    }, 1000);
  };

  const handleAudioStart = () => {
    if (timeoutIdRef.current) {
      clearTimeout(timeoutIdRef.current);
    }
    setShowAnswer(false);
    SpeechRecognition.stopListening();
  };
  useEffect(() => {
    if (showQuestions) {
      const audioElement = audioRef.current;

      if (audioElement) {
        audioElement.addEventListener("ended", handleAudioEnd);
        audioElement.addEventListener("play", handleAudioStart);
      }

      return () => {
        if (audioElement) {
          audioElement.removeEventListener("ended", handleAudioEnd);
          audioElement.removeEventListener("play", handleAudioStart);
        }
      };
    }
  }, [showQuestions, audioRef]);
  const handleSetConclusion = async (currentAnswerIndex) => {
    let answer = tranascriptRef.current || "";

    const saveQuestionData = (audioId = null) => {
      if (interviewQuestions[currentAnswerIndex]?.question) {
        const questionData = {
          question: interviewQuestions[currentAnswerIndex].question,
          answer: answer,
          audio: audioId,
          questionIndex: currentAnswerIndex + 1,
          timestamp: new Date().toISOString(),
        };

        setConclusion((prev) => {
          const isAlreadySaved = prev.some(
            (item) => item.questionIndex === currentAnswerIndex + 1
          );

          if (isAlreadySaved) {
            console.log(
              `Question ${currentAnswerIndex + 1} already saved, skipping...`
            );
            return prev;
          }

          const newConclusion = [...prev, questionData];
          return newConclusion;
        });
      }
    };

    if (!mediaRef.current) {
      console.log(`No mediaRef for question ${currentAnswerIndex + 1}`);
      saveQuestionData(null);
      return;
    }

    if (mediaRef.current.state !== "recording") {
      console.log(`Not recording for question ${currentAnswerIndex + 1}`);
      saveQuestionData(null);
      return;
    }

    return new Promise((resolve) => {
      let isResolved = false;
      let hasAudioProcessed = false;

      const safetyTimeout = setTimeout(() => {
        if (!isResolved && !hasAudioProcessed) {
          saveQuestionData(null);
          isResolved = true;
          resolve();
        }
      }, 15000);

      mediaRef.current.onstop = async () => {
        if (isResolved) {
          return;
        }

        hasAudioProcessed = true;

        try {
          let audioId = null;

          if (chunkref.current && chunkref.current.length > 0) {
            const audioBlob = new Blob(chunkref.current, {
              type: "audio/webm",
            });

            if (audioBlob.size > 1000) {
              const audioFile = new File(
                [audioBlob],
                `question_${currentAnswerIndex + 1}.webm`,
                {
                  type: "audio/webm",
                }
              );

              const formData = new FormData();
              formData.append("audio", audioFile);

              const audioUploadId = `audio_upload_${
                currentAnswerIndex + 1
              }_${Date.now()}`;
              setPendingApiCalls((prev) => new Set([...prev, audioUploadId]));

              try {
                const uploadResult = await uploadAudioMutation.mutateAsync(
                  formData
                );
                audioId = uploadResult?.fileId;
              } catch (uploadError) {
                console.error(
                  `Upload failed for question ${currentAnswerIndex + 1}:`,
                  uploadError
                );
              } finally {
                setPendingApiCalls((prev) => {
                  const newSet = new Set(prev);
                  newSet.delete(audioUploadId);
                  return newSet;
                });
              }
            } else {
              console.log(
                `Audio too small (${audioBlob.size}B) for question ${
                  currentAnswerIndex + 1
                }`
              );
            }
          } else {
            console.log(
              `No audio chunks for question ${currentAnswerIndex + 1}`
            );
          }

          if (!isResolved) {
            saveQuestionData(audioId);
          } else {
            console.log(
              `Question ${currentAnswerIndex + 1} was already saved by timeout`,
            );
          }

          chunkref.current = [];
        } catch (error) {
          console.error(
            `Error processing question ${currentAnswerIndex + 1}:`,
            error,
          );
          if (!isResolved) {
            saveQuestionData(null);
          }
          chunkref.current = [];
        } finally {
          clearTimeout(safetyTimeout);

          if (!isResolved) {
            isResolved = true;
            resolve();
          }
        }
      };

      try {
        mediaRef.current.stop();
      } catch (stopError) {
        console.error(`Error stopping recording:`, stopError);
        clearTimeout(safetyTimeout);

        if (!isResolved) {
          saveQuestionData(null);
          isResolved = true;
          resolve();
        }
      }
    });
  };

  const handleGoToNextQuestion = useCallback(async () => {
    // blocked Interview Next Question
    if (isBlocked || isInterviewSubmited?.open) {
      console.warn("Interview is blocked or already submitted");
      return;
    }
    if (currentAnswer === interviewQuestions.length) return;

    setIsProcessingQuestion(true);

    setIsRunning(false);
    SpeechRecognition.stopListening();
    if (timeoutIdRef.current) {
      clearTimeout(timeoutIdRef.current);
    }

    try {
      await handleSetConclusion(currentAnswerRef?.current);
      await waitForApiCompletion();
      resetTranscript();
      if (currentAnswerRef.current < interviewQuestions?.length - 1) {
        setCurrentAnswer((prev) => prev + 1);
      }

      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current.currentTime = 0;
      }

      handleResetTimer();
    } catch (error) {
      console.error("Error in handleGoToNextQuestion:", error);
    } finally {
      setIsProcessingQuestion(false);
    }
  }, [currentAnswer, interviewQuestions]);

  const waitForApiCompletion = () => {
    return new Promise((resolve) => {
      const checkApiCompletion = () => {
        if (pendingApiCalls.size === 0) {
          resolve();
        } else {
          console.log(
            `⏳ Waiting for ${pendingApiCalls.size} API calls to complete...`,
          );
          setTimeout(checkApiCompletion, 500);
        }
      };
      checkApiCompletion();
    });
  };

  const handleStopStream = () => {
    try {
      if (localStream) {
        localStream.getTracks().forEach((track) => track.stop());

        if (localVideoRef.current) {
          localVideoRef.current.srcObject = null;
        }

        setLocalStream(null);
      }
    } catch (error) {
      console.error("Error stopping the stream:", error);
      alert("Unable to stop the camera feed.");
    }
  };

  const handleSubmitInterview = async () => {
    if (isBlocked) return; // blocked
    if (interviewQuestions.length > 0) {
      if (currentAnswer === interviewQuestions.length - 1) {
        setIsProcessingQuestion(true);

        if (!mediaRef.current) {
          console.error("No active recorder to submit interview.");
          setIsProcessingQuestion(false);
          return;
        }

        mediaRef.current.onstop = async () => {
          let id = null;
          if (!chunkref.current.length) {
            console.error("No audio data captured.");
            setIsProcessingQuestion(false);
            return;
          }

          const audioBlob = new Blob(chunkref.current, { type: "audio/mpeg" });
          const audioFile = new File([audioBlob], "recorded_audio.mp3", {
            type: "audio/mpeg",
          });

          setAudioFile(audioFile);
          const audioUrl = URL.createObjectURL(audioBlob);
          setAudioRecord(audioUrl);

          const formData = new FormData();
          formData.append("audio", audioFile);

          try {
            await waitForApiCompletion();
            resetTranscript();
            const uploadResult = await uploadAudioMutation.mutateAsync(
              formData,
            );
            id = uploadResult?.fileId;

            const finalconclusion = {
              candidate_id: interviewDetail?._id,
              recreuiter_email: interviewDetail?.recruiterEmail,
              question_and_answer: [
                ...conclusion,
                {
                  question: interviewQuestions[currentAnswer].question,
                  answer: tranascriptRef.current ? tranascriptRef.current : "",
                  audio: id,
                },
              ],
            };

            await interviewSubmitMutation.mutateAsync(finalconclusion);

            setIsInterviewCompleted(true);
            isInterviewCompletedRef.current = true;

            setSnackbar((prev) => ({
              ...prev,
              open: false,
            }));

            setIsStickyWarning(false);

            handle.exit();
            setIsInterviewSubmited({
              open: true,
              message:
                "Thank you for your interest in joining Element Technologies. We look forward to speaking with you and learning more about your expertise.",
              title: "Completed",
            });

            if (audioRef.current) {
              audioRef.current.pause();
              audioRef.current.currentTime = 0;
            }
            handleStopStream();
          } catch (error) {
            console.error("Error submitting interview:", error);
          } finally {
            setIsProcessingQuestion(false);
          }
        };
        mediaRef.current?.stop();
      }
    }
  };

  const handlePlayQuestion = () => {
    timeoutIdRef.current = setTimeout(() => {
      setIsTimerExpired(true);
      if (currentAnswerRef.current === interviewQuestions.length - 1) {
        handleTimerAutoSubmit();
      } else {
        handleTimerAutoNext();
      }
    }, 180000);
  };

  useEffect(() => {
    if (interviewQuestions.length > 0 && !isInterviewSubmited?.open) {
      if (conclusion?.length === interviewQuestions.length) {
        const data = {
          candidate_id: interviewDetail?._id,
          recreuiter_email: interviewDetail?.recruiterEmail,
          question_and_answer: conclusion,
        };
        interviewSubmitMutation.mutate(data, {
          onSuccess: (data) => {
            setIsInterviewCompleted(true);
            isInterviewCompletedRef.current = true;

            setSnackbar((prev) => ({
              ...prev,
              open: false,
            }));

            setIsStickyWarning(false);

            handle.exit();
            setIsInterviewSubmited({
              open: true,
              message:
                "Thank you for your interest in joining Element Technologies. We look forward to speaking with you and learning more about your expertise.",
              title: "Completed",
            });
          },
        });
      }
    }
  }, [conclusion, interviewQuestions.length]);

  useEffect(() => {
    if (
      timeLeft &&
      timeLeft.asSeconds() <= 0 &&
      showQuestions &&
      !isInterviewSubmited.open &&
      interviewQuestions.length > 0
    ) {
      console.log("Time's up! Processing current question...");
      setIsTimerExpired(true);

      if (currentAnswer === interviewQuestions.length - 1) {
        handleTimerAutoSubmit();
      } else {
        handleTimerAutoNext();
      }
    }
  }, [
    timeLeft,
    showQuestions,
    isInterviewSubmited.open,
    currentAnswer,
    interviewQuestions.length,
  ]);

  const handleTimerAutoNext = async () => {
    try {
      setIsProcessingQuestion(true);
      SpeechRecognition.stopListening();

      if (timeoutIdRef.current) {
        clearTimeout(timeoutIdRef.current);
      }

      await handleSetConclusion(currentAnswerRef?.current);

      await waitForApiCompletion();

      resetTranscript();
      setCurrentAnswer((prev) => prev + 1);

      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current.currentTime = 0;
      }

      setIsRunning(false);
      handleResetTimer();
      setIsTimerExpired(false);
    } catch (error) {
      console.error("Error in handleTimerAutoNext:", error);
    } finally {
      setIsProcessingQuestion(false);
    }
  };

  const handleTimerAutoSubmit = async () => {
    try {
      setIsProcessingQuestion(true);
      SpeechRecognition.stopListening();

      if (timeoutIdRef.current) {
        clearTimeout(timeoutIdRef.current);
      }

      if (
        currentAnswer === interviewQuestions.length - 1 ||
        conclusion.length === interviewQuestions.length - 1
      ) {
        if (mediaRef.current && mediaRef.current.state === "recording") {
          mediaRef.current.onstop = async () => {
            await processTimerSubmission();
          };
          mediaRef.current.stop();
        } else {
          await processTimerSubmission();
        }
      } else {
        setIsProcessingQuestion(false);
      }
    } catch (error) {
      console.error("Error during timer auto-submission:", error);
      setIsProcessingQuestion(false);
    }
  };

  const processTimerSubmission = async () => {
    try {
      let finalConclusion = [...conclusion];

      await waitForApiCompletion();

      if (chunkref.current.length > 0) {
        const audioBlob = new Blob(chunkref.current, { type: "audio/mpeg" });
        const audioFile = new File([audioBlob], "recorded_audio.mp3", {
          type: "audio/mpeg",
        });

        const formData = new FormData();
        formData.append("audio", audioFile);

        try {
          const uploadResult = await uploadAudioMutation.mutateAsync(formData);
          finalConclusion.push({
            question: interviewQuestions[currentAnswer]?.question || "",
            answer: tranascriptRef.current || "",
            audio: uploadResult?.fileId,
          });
        } catch (uploadError) {
          console.error("Final audio upload failed:", uploadError);
          finalConclusion.push({
            question: interviewQuestions[currentAnswer]?.question || "",
            answer: tranascriptRef.current || "",
            audio: null,
          });
        }
      } else if (tranascriptRef.current && interviewQuestions[currentAnswer]) {
        finalConclusion.push({
          question: interviewQuestions[currentAnswer].question,
          answer: tranascriptRef.current,
          audio: null,
        });
      }

      const submissionData = {
        candidate_id: interviewDetail?._id,
        recreuiter_email: interviewDetail?.recruiterEmail,
        question_and_answer: finalConclusion,
      };

      console.log(
        "Timer expired - submitting interview with",
        finalConclusion.length,
        "answers",
      );

      await interviewSubmitMutation.mutateAsync(submissionData);
      setIsInterviewCompleted(true);
      isInterviewCompletedRef.current = true;
      setSnackbar((prev) => ({
        ...prev,
        open: false,
      }));

      setIsStickyWarning(false);

      handle.exit();
      setIsInterviewSubmited({
        open: true,
        message:
          "Time's up! Thank you for your interest in joining Element Technologies. We look forward to speaking with you and learning more about your expertise.",
        title: "Interview Completed",
      });

      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current.currentTime = 0;
      }
      handleStopStream();
      chunkref.current = [];
    } catch (error) {
      console.error("Error in processTimerSubmission:", error);
      setIsInterviewSubmited({
        open: true,
        message:
          "Time expired and there was an error submitting your interview. Please contact support.",
        title: "Submission Error",
      });
    } finally {
      setIsProcessingQuestion(false);
      setIsTimerExpired(false);
    }
  };

  useEffect(() => {
    currentAnswerRef.current = currentAnswer;
    setBtnEnable(false);
  }, [currentAnswer]);

  // Loads/plays the next question's audio only after React has committed the
  // new `currentAnswer` (and with it the <audio src> in VideoSection) to the
  // DOM. Doing this imperatively right after setCurrentAnswer (as the two
  // "go to next question" handlers used to) reloads the DOM's still-stale
  // (previous question's) src, since React state updates aren't applied
  // synchronously. Question 1 is intentionally excluded: it's started by the
  // post-reference-video countdown flow in VideoSection, not by a
  // currentAnswer change.
  useEffect(() => {
    if (isFirstQuestionRef.current) {
      isFirstQuestionRef.current = false;
      return;
    }
    if (
      !audioRef.current ||
      !showQuestions ||
      currentAnswer === interviewQuestions?.length
    ) {
      return;
    }

    audioRef.current.pause();
    audioRef.current.currentTime = 0;
    audioRef.current.onloadeddata = () => {
      if (audioRef.current) {
        playAudioResilient(audioRef.current, handleAudioEnd);
      }
    };
    audioRef.current.load();
  }, [currentAnswer]);

  useEffect(() => {
    isQuestionEndRef.current = isQuestionEnd;
  }, [isQuestionEnd]);
  useEffect(() => {
    tranascriptRef.current = transcript;
  }, [transcript]);
  const entireFullScreen = () => {
    const elem = document.documentElement;
    elem.requestFullscreen();
  };

  const [timeLeft1, setTimeLeft1] = useState(moment.duration(0));

  useEffect(() => {
    if (!interviewDetail?.startTime) return;

    const startTime = moment(interviewDetail.startTime);
    const now = moment();
    const duration = moment.duration(startTime.diff(now));

    setTimeLeft1(duration);

    if (duration.asSeconds() > 0) {
      const intervalId = setInterval(() => {
        setTimeLeft1((prevTime) => {
          if (prevTime.asSeconds() <= 0) {
            clearInterval(intervalId);
            return moment.duration(0);
          }
          return moment.duration(prevTime.asSeconds() - 1, "seconds");
        });
      }, 1000);

      return () => clearInterval(intervalId);
    }
  }, [interviewDetail?.startTime]);

  useEffect(() => {
    const updateCountdown = () => {
      const now = moment();
      const starttime = moment.utc(startTime);
      const duration = moment.duration(starttime.diff(now));
      const endedtime = moment(endTime);
      const validTime = now.utc().isBetween(starttime, endedtime);
      if (duration.asSeconds() > 0) {
        setInterviewDialogueBoxError((prev) => ({
          ...prev,
          message: `Interview not started. The meeting is scheduled to start in ${
            duration.days() > 0 ? duration.days() + " days " : ""
          }${duration.hours() > 0 ? duration.hours() + " hr " : ""}${
            duration.minutes() > 0 ? duration.minutes() + " min " : ""
          }${duration.seconds()} sec`,
          showStartButton: false,
        }));
      } else {
        if (validTime) {
          setInterviewDialogueBoxError((prev) => ({
            ...prev,
            message:
              "Please read the script aloud for at least 18 seconds to verify your audio and identity. Note: Say your actual phone number instead of XXX-XXX-XXXX.",
            showStartButton: true,
          }));
        }
      }
    };

    updateCountdown();
    const intervalId = setInterval(updateCountdown, 1000);

    return () => clearInterval(intervalId);
  }, [startTime, endTime]);

  useEffect(() => {
    console.log(`🎯 CURRENT STATE:
      - Current Question: ${currentAnswer + 1}/${interviewQuestions.length}
      - Conclusions Saved: ${conclusion.length}
      - Pending API Calls: ${pendingApiCalls.size}
      - Is Processing: ${isProcessingQuestion}
      - Timer Expired: ${isTimerExpired}
    `);
  }, [
    currentAnswer,
    conclusion.length,
    interviewQuestions.length,
    pendingApiCalls.size,
    isProcessingQuestion,
    isTimerExpired,
  ]);

  if (!isOtpVerified && !isInterviewSubmited?.open) {
    return (
      <EmailOTPVerification
        maskedEmail={maskedEmail}
        candidateName={candidateName}
        onSendOTP={handleSendOTP}
        onVerifyOTP={handleVerifyOTP}
        isSendingOTP={sendInterviewOTPMutation.isPending}
        isVerifyingOTP={interviewValidateMutation.isPending}
        errorMsg={otpErrorMsg}
      />
    );
  }

  return (
    <>
      <FullScreen handle={handle} onChange={onFullScreenChange}>
        {showWelcomeScreen ? (
          <Box className="full_main_container" sx={{ height: "100%" }}>
            <InterviewWelcome
              interviewDetail={interviewDetail}
              onStart={() => setShowWelcomeScreen(false)}
              startInterview={startInterview}
              startRecording={startVerification}
              showSnackbar={showSnackbar}
              enterFullScreen={() => handle.enter()}
            />

            <InvalidTokenDialog
              open={open}
              errorMessage={errorMessage}
              setOpen={setOpen}
            />

            <MeetingTimeDilogue
              message={interviewDialogueBoxError.message}
              onClose={() => {}}
              open={interviewDialogueBoxError.open}
              startInterview={startInterview}
              showStartButton={interviewDialogueBoxError.showStartButton}
              timeLeft={timeLeft1}
              isStartButtonDisabled={isStartButtonDisabled}
            />

            <InterviewStatusDialogue
              open={isInterviewSubmited?.open}
              message={isInterviewSubmited.message}
              title={isInterviewSubmited.title}
              InterviewStatusDialogue={InterviewStatusDialogue}
            />
          </Box>
        ) : (
          <InterviewOtherWrapper container sx={{ height: "100vh" }}>
            <Grid
              item
              className="interview__header--container"
              sx={{
                width: "100%",
                height: "60px",
                // backgroundColor: "rgba(255, 255, 255)",
                backgroundColor: "rgba(255, 255, 255)",
              }}
            >
              {!isInterviewSubmited?.open && (
                <img className="company__logo" src={logo} alt="Berlin" height="43px" />
              )}
            </Grid>
            <Grid item>
              <Grid className="body__conatiner" container>
                {/* <InvalidTokenDialog
                  open={open}
                  errorMessage={errorMessage}
                  setOpen={setOpen}
                /> */}
                {/* <MeetingTimeDilogue
                  message={interviewDialogueBoxError.message}
                  onClose={() => {}}
                  open={interviewDialogueBoxError.open}
                  startInterview={startInterview}
                  showStartButton={interviewDialogueBoxError.showStartButton}
                  timeLeft={timeLeft1}
                  isStartButtonDisabled={isStartButtonDisabled}
                /> */}
                {/* <MeetingTimeDilogue
                message={facenotdetected.message}
                onClose={() => {}}
                open={facenotdetected.open}
              /> */}
                <InterviewStatusDialogue
                  open={isInterviewSubmited?.open}
                  message={isInterviewSubmited.message}
                  title={isInterviewSubmited.title}
                  InterviewStatusDialogue={InterviewStatusDialogue}
                />
                {loadings && <FullScreenLoader />}
                <Grid item xs={6} className="video__question__container--grid">
                  {!isInterviewSubmited?.open && (
                    <ToastProvider>
                      <VideoSection
                        // onInterviewCancelled={handleInterviewCancellation}
                        localVideoRef={localVideoRef}
                        localStream={localStream}
                        audioRef={audioRef}
                        handleAudioEnd={handleAudioEnd}
                        setShowQuestions={setShowQuestions}
                        timeLeft={timeLeft}
                        isRunning={isRunning}
                        setShowStartTimer={setShowStartTimer}
                        showStartTimer={showStartTimer}
                        currentAnswer={currentAnswer}
                        handleGoToNextQuestion={handleGoToNextQuestion}
                        showQuestions={showQuestions}
                        interviewQuestions={interviewQuestions}
                        isInterviewSubmited={isInterviewSubmited?.open}
                        setFaceDetection={setFaceDetection}
                        setIsNet={setIsNet}
                        currentAnswerRef={currentAnswerRef}
                        interviewDetail={interviewDetail}
                        setIsInterviewSubmited={setIsInterviewSubmited}
                        setPendingApiCalls={setPendingApiCalls}
                        setIsProcessingQuestion={setIsProcessingQuestion}
                        isProcessingQuestion={isProcessingQuestion}
                      />
                    </ToastProvider>
                  )}
                </Grid>
                <Grid item xs={6} className="answer__container--grid">
                  {!isInterviewSubmited?.open && (
                    <ChatSection
                      transcript={transcript}
                      handleGoToNextQuestion={handleGoToNextQuestion}
                      interviewQuestions={interviewQuestions}
                      currentAnswer={currentAnswer}
                      handleSubmitInterview={handleSubmitInterview}
                      btnEnable={btnEnable}
                      setBtnEnable={setBtnEnable}
                      isProcessingQuestion={isProcessingQuestion}
                      pendingApiCalls={pendingApiCalls}
                    />
                  )}
                </Grid>
              </Grid>
            </Grid>
          </InterviewOtherWrapper>
        )}
        <Snackbar
          open={snackbar.open}
          autoHideDuration={isStickyWarning ? null : 5000}
          onClose={
            isStickyWarning
              ? undefined
              : () => setSnackbar((prev) => ({ ...prev, open: false }))
          }
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          sx={{ zIndex: 9999999 }}
        >
          <Alert
            severity={snackbar.severity}
            variant="filled"
            sx={{ width: "100%", fontSize: "1rem" }}
            onClose={
              !isStickyWarning
                ? () => setSnackbar((prev) => ({ ...prev, open: false }))
                : undefined
            }
          >
            {snackbar.message}
          </Alert>
        </Snackbar>
      </FullScreen>
      {showPopup &&
        // !isInterviewCancelled
        !isInterviewCompleted &&
        !interviewDialogueBoxError.open && (
          <InterviewFullScreenDilogue
            open={showPopup}
            onClose={() => setShowPopup(false)}
            onEnterFullScreen={() => {
              handle.enter();
              setShowPopup(false);
            }}
          />
        )}
    </>
  );
};

export default Interview;
